// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"34c681f3","455":"6a7a7386","904":"d73570d7","977":"8cab160e"}[chunkId] + ".chunk.js";
};